var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.25,
    stroke: "#AD0C24",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.012 7.752a.3.3 0 000 .424l1.612 1.612a.3.3 0 010 .424l-1.612 1.612a.3.3 0 000 .425l.74.739a.3.3 0 00.424 0l1.612-1.612a.3.3 0 01.424 0l1.612 1.612a.3.3 0 00.425 0l.739-.74a.3.3 0 000-.424l-1.612-1.612a.3.3 0 010-.424l1.612-1.612a.3.3 0 000-.424l-.74-.74a.3.3 0 00-.424 0l-1.612 1.612a.3.3 0 01-.424 0L8.176 7.012a.3.3 0 00-.425 0l-.739.74z",
    fill: "#AD0C24"
  })));
}
export default SvgError;